import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }

  p.description {
    color: var(--color-text);
    margin: 0;
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    grid-gap: 10px;
    margin: 20px auto 0;
  }
`;
